import communicationService from '@/services/PostMessageCommunation/CommunicationService';
import dataKeys from '@/services/PostMessageCommunation/enums/DataKeys';

export default {
  bind(el, binding) {
    const tag = binding.value; // Etiket bilgisi
    if (tag) {
      communicationService.sendDataToParent({
        key: dataKeys.STATISTICS,
        value: tag,
      });
    }
  },
};
